exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title {\r\n    text-transform: none;\r\n}\r\n\r\n.select-message {\r\n    font-weight: 600;\r\n}", ""]);

// exports
